import React from "react";
import SEO from "../../../components/SEO";

export default function Disclaimer() {
  return (
    <>
    <SEO
  title="Avis de non-responsabilité | einsured.ca Canada"
  description="Consultez les conditions, prix, périodes d’attente et exclusions des assurances médicales pour visiteurs au Canada et Super Visa avec einsured.ca. "   
/>
    <div className="bg-white text-[#111827]">
      <section className="max-w-6xl mx-auto px-4 sm:px-6 md:px-20 pt-14 sm:pt-16 pb-16 sm:pb-20">
        {/* MAIN HEADING */}
        <h1 className="text-2xl sm:text-4xl md:text-5xl font-bold text-center mb-8 sm:mb-12 text-[#49628b]">
          Avis de non-responsabilité sur les devis et polices d'assurance
        </h1>

        <div className="space-y-4 text-sm sm:text-base leading-relaxed">
          {/* Intro section */}
          <h2 className="text-lg sm:text-xl font-bold text-[#111827]">
            Produits d'assurance médicale d'urgence pour les visiteurs au Canada
            et le Super Visa
          </h2>
          <p>
            Veuillez noter que les conditions d'admissibilité, les avantages,
            les exclusions et les limitations varieront selon le plan
            d'assurance et la compagnie que vous choisissez. Pour votre
            référence, le libellé de la police est disponible pour examen.
          </p>

          {/* Prices */}
          <h2 className="mt-8 text-lg sm:text-xl font-bold text-[#111827]">
            Prix
          </h2>
          <p>
            Les prix correspondent aux montants de prime à payer par l'assuré
            ou l'acheteur pour le plan sélectionné. Ces montants de prime sont
            pour toute la durée choisie en fonction de l'âge et des conditions
            médicales telles que spécifiées par l'assuré.
          </p>
          <p>
            Les prix pour toutes les polices et tous les investissements
            mentionnés sur ce site Web sont en dollars canadiens (CAD) et
            peuvent être soumis à des taxes. La compagnie d'assurance se
            réserve tous les droits d'apporter des modifications à ces prix à
            tout moment sans préavis. Tous les prix sont fournis à titre
            informatif uniquement. Pour obtenir un tarif final et garanti,
            veuillez consulter nos conseillers en sécurité financière agréés.
          </p>
          <p>
            Si vous choisissez de payer en versements mensuels, certaines
            conditions et des frais supplémentaires s'appliquent conformément
            au libellé de la police de la compagnie d'assurance que vous
            choisissez.
          </p>

          {/* Waiting Period */}
          <h2 className="mt-8 text-lg sm:text-xl font-bold text-[#111827]">
            Période d'attente
          </h2>
          <p>
            Si une assurance médicale d'urgence est souscrite alors que l'assuré
            séjourne actuellement au Canada, une période d'attente peut
            s'appliquer. La période d'attente dans une police d'assurance fait
            référence à une période de temps spécifique pendant laquelle la
            couverture n'est pas fournie même si la police entre en vigueur.
          </p>
          <p>
            La période d'attente peut varier selon le type d'assurance et les
            conditions spécifiques de la police, allant de 24 heures à 7 jours.
          </p>

          {/* Pre-existing condition */}
          <h2 className="mt-8 text-lg sm:text-xl font-bold text-[#111827]">
            Condition préexistante
          </h2>
          <p>
            Toute condition médicale, blessure ou maladie pour laquelle l'assuré
            a
          </p>
          <ul className="list-disc pl-6 sm:pl-8 space-y-1">
            <li>présenté/présenté des symptômes,</li>
            <li>
              été diagnostiqué et a reçu des soins médicaux d'un médecin,
            </li>
            <li>reçu/reçu un traitement et des médicaments, ou</li>
            <li>conformément aux conditions indiquées dans le libellé de la police</li>
          </ul>
          <p>
            avant la date de départ peut être considérée comme une condition
            médicale préexistante.
          </p>
          <p>
            Le critère pour fournir une couverture pour les conditions médicales
            préexistantes est généralement la période de stabilité médicale de
            l'assuré de 120 à 180 jours avant la date de début de l'assurance.
            Pour plus d'informations concernant vos conditions médicales
            préexistantes et leur couverture, veuillez contacter nos conseillers
            en assurance qui vous poseront toutes les questions avant de
            confirmer votre devis final.
          </p>

          {/* Deductible */}
          <h2 className="mt-8 text-lg sm:text-xl font-bold text-[#111827]">
            Franchise
          </h2>
          <p>
            Le montant d'argent payé par un assuré/souscripteur de police lors
            de la réclamation des coûts en vertu d'une police d'assurance est
            appelé franchise. Ces franchises permettent le partage des risques
            entre l'assuré et le fournisseur/la compagnie d'assurance.
          </p>
          <p>
            Les franchises réduisent le montant de la prime à payer par
            l'assuré. Elles peuvent être soit un montant fixe en dollars, soit
            un certain pourcentage que l'assuré accepte de payer de sa poche.
            Ces montants peuvent être sélectionnés au moment de l'achat de la
            police. Nous offrons à l'assuré la possibilité de choisir les
            franchises entre 0 $ et 10 000 $.
          </p>
          <p>
            Exemple : Si un souscripteur de police achète une police médicale
            avec une couverture de 25 000 $ et une franchise de 250 $. Au moment
            d'effectuer une réclamation pour des frais médicaux d'une valeur de
            5 000 $, le souscripteur de police devra payer la franchise de 250 $
            et les 4 750 $ restants seront couverts par la compagnie d'assurance
            conformément à la police.
          </p>

          {/* About einsured.ca Inc. */}
          <h2 className="mt-8 text-lg sm:text-xl font-bold text-[#111827]">
            À propos d'einsured.ca Inc.
          </h2>
          <p>
            einsured.ca est un organisme d'assurance-vie agréé avec une licence
            Vie et Accidents &amp; Maladie (A&amp;M). Actuellement agréé en AB,
            BC, MB, ON et QC. Aman Ahuja représente l'agence dans ces provinces
            et est agréé dans toutes les provinces et territoires du Canada.
          </p>
          <p>
            Tous nos conseillers sont agréés dans les provinces où ils exercent.
            Ils respectent toutes les directives des conseils d'assurance et
            restent pleinement conformes à toutes les règles et réglementations.
          </p>
          <p>
            Pour des informations détaillées, veuillez{" "}
            <a
              href="https://book.einsured.ca/widget/bookings/ei-team"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sky-600 underline"
            >
              prendre rendez-vous
            </a>{" "}
            avec l'un de nos conseillers agréés.
          </p>
        </div>
      </section>
    </div>
    </>
  );
}
